import { NewsItem } from '../../../../shared/news';

export const loadAdminNews = () =>
    fetch('/api/getAllNews')
        .then((res) => res.json() as Promise<NewsItem[]>)
        .catch(() => undefined);
